import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import Layout from "components/layout";
import { RegisterButton } from "components/registerButton";
import { bindActionCreators } from "redux";
import { Creators as LocationActions } from "store/location/location-duck";
import { ILocationData } from "store/location/location-model";
import { Creators as ReadersActions } from "store/readers-tags/readers/readers-duck";
import { IForm, IItems } from "store/readers-tags/readers/readers-model";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { IUserData, MenuItemActive } from "store/user-session/user-session-model";
import { Roles } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import ReaderDrawer from "./components/drawer";
import FormReaderAntenna from "./components/form";
import ReadersFilter from "./filter";
import ReadersGrid from "./grid";
import * as S from "./index.styled";
import { onConfirmDrawerUpdateReaderAntenna } from "./readers.service";
import { handleOnCheckConfirmUpdateReaderAntenna } from "./utils";

interface IPropsScreenReaders {
  form?: IForm;
  isLoading?: boolean;
  isLoadingTable?: boolean;
  userData?: IUserData;
  items?: Array<IItems>;
  totalItems?: number;
  pageIndex?: number;
  searchFilter?: string;
  visibleDrawer?: boolean;
  isLoadingForm?: boolean;
  isLoadingDrawer?: boolean;
  locationActiveList?: ILocationData[];
}

interface IDispatchProps {
  userSessionMenuItemActive?: (...args) => void;
  readersRegisterFetchAsync?: (...args) => void;
  readersChangeFieldValue?: (...args) => void;
  readersUpdateFilter?: (...args) => void;
  readersShowDrawer?: () => void;
  readersHideDrawer?: () => void;
  locationActiveFetchAsync?: () => void;
  readersUpdateFormAntenna?: (...args) => void;
  readersUpdateFormReader?: (...args) => void;
  readersRemoveAntenna?: (...args) => void;
  readersAntennaFetchByIdAsync?: (...args) => void;
  readersAntennaReaderDeleteByIdAsync?: (...args) => void;
  readersAntennaUpdatedAsync?: () => void;
  readersShowDeleteModal?: () => void;
  readersHideDeleteModal?: () => void;
}

export type IProps = IPropsScreenReaders & IDispatchProps;

const Readers = ({
  form,
  items,
  userData,
  pageIndex,
  isLoading,
  totalItems,
  searchFilter,
  visibleDrawer,
  isLoadingForm,
  isLoadingTable,
  isLoadingDrawer,
  locationActiveList,
  readersHideDrawer,
  readersShowDrawer,
  readersUpdateFilter,
  readersRemoveAntenna,
  readersHideDeleteModal,
  readersUpdateFormReader,
  readersChangeFieldValue,
  readersShowDeleteModal,
  readersUpdateFormAntenna,
  locationActiveFetchAsync,
  userSessionMenuItemActive,
  readersRegisterFetchAsync,
  readersAntennaUpdatedAsync,
  readersAntennaFetchByIdAsync,
  readersAntennaReaderDeleteByIdAsync,
}: IProps) => {
  const TITLE_PAGE = useTranslation({ id: "readers" });
  const ERROR_VALIDATING_FORM = useTranslation({ id: "error_validating_form" });
  const [showConfirmDisableReader, setShowConfirmDisableReader] = useState(false);

  const isAdmin = userData.role === Roles.ADMIN;
  const [formReader] = Form.useForm();
  const [formAntenna] = Form.useForm();

  useEffect(() => {
    userSessionMenuItemActive(MenuItemActive.READERS);
  }, [userSessionMenuItemActive]);

  useEffect(() => {
    if (!visibleDrawer) {
      formReader.resetFields();
      formAntenna.resetFields();
    }
  }, [visibleDrawer]);

  const handleOnConfirmDrawerReaderAntenna = () => {
    onConfirmDrawerUpdateReaderAntenna({
      formReader: formReader,
      formAntenna: formAntenna,
      readersAntennaUpdatedAsync,
      messageDescription: ERROR_VALIDATING_FORM,
    });
  };

  return (
    <Layout title={TITLE_PAGE} isLoading={isLoading} role={userData.role}>
      <S.DefaultContainer>
        <S.HeaderContainer isAdmin={isAdmin}>
          {isAdmin && <RegisterButton id="reader_register" title="reader_new_register" dataTestId="readerRegister" onClick={readersShowDrawer} size="240px" />}
          <ReadersFilter readersUpdateFilter={readersUpdateFilter} readersChangeFieldValue={readersChangeFieldValue} />
        </S.HeaderContainer>
        <ReaderDrawer
          width="680"
          confirmbuttontxt={useTranslation({ id: "register" })}
          cancelbuttontxt={useTranslation({ id: "cancel" })}
          maskClosable={true}
          disabled={isLoadingDrawer}
          onConfirm={handleOnConfirmDrawerReaderAntenna}
          onCheckForm={() => handleOnCheckConfirmUpdateReaderAntenna(formReader, formAntenna, setShowConfirmDisableReader, handleOnConfirmDrawerReaderAntenna)}
          setShowConfirmDisableReader={setShowConfirmDisableReader}
          popConfirm={showConfirmDisableReader}
          title={useTranslation({ id: "configuration" })}
          placement="right"
          closable={false}
          formId={form?.reader?.id}
          destroyOnClose={true}
          onClose={readersHideDrawer}
          open={visibleDrawer}
          isLoading={isLoadingForm}
        >
          <FormReaderAntenna
            form={form}
            formReader={formReader}
            formAntenna={formAntenna}
            isLoadingForm={isLoadingForm}
            locationActiveFetchAsync={locationActiveFetchAsync}
            locationActiveList={locationActiveList}
            readersUpdateFormReader={readersUpdateFormReader}
            readersUpdateFormAntenna={readersUpdateFormAntenna}
            readersRemoveAntenna={readersRemoveAntenna}
          />
        </ReaderDrawer>
        <ReadersGrid
          readersRegisterFetchAsync={readersRegisterFetchAsync}
          readersChangeFieldValue={readersChangeFieldValue}
          readersShowDrawer={readersShowDrawer}
          readersAntennaFetchByIdAsync={readersAntennaFetchByIdAsync}
          readersAntennaReaderDeleteByIdAsync={readersAntennaReaderDeleteByIdAsync}
          readersShowDeleteModal={readersShowDeleteModal}
          readersHideDeleteModal={readersHideDeleteModal}
          items={items}
          totalItems={totalItems}
          pageIndex={pageIndex}
          searchFilter={searchFilter}
          isLoadingTable={isLoadingTable}
        />
      </S.DefaultContainer>
    </Layout>
  );
};
const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...UserSessionActions, ...LocationActions, ...ReadersActions }, dispatch);

const mapStateToProps = (state) => ({
  form: state.Readers.form,
  items: state.Readers.items,
  isLoading: state.Readers.isLoading,
  totalItems: state.Readers.totalItems,
  userData: state.UserSession.userData,
  searchFilter: state.Readers.searchFilter,
  pageIndex: state.Readers.filter.pageIndex,
  isLoadingForm: state.Readers.isLoadingForm,
  visibleDrawer: state.Readers.visibleDrawer,
  isLoadingTable: state.Readers.isLoadingTable,
  isLoadingDrawer: state.Readers.isLoadingDrawer,
  locationActiveList: state.Location.locationActiveList,
});

export default connect(mapStateToProps, mapDispatchToActions)(Readers);
